import React from 'react'
import './InitialThankYouForm.scss'
import Typography from 'Components/Base/Typography'
import styled from 'styled-components'

export default function InitialThankYouForm() {
  return (
    <StyledContainer>
      <Typography size={64} font="bold">
        We'll Be Calling Soon to Schedule
      </Typography>
      <Typography size={28} styles={{ marginTop: 40 }}>
        A member advocate will call you within 24-48 hours to set up an appointment based on your preferences.
        <span style={{ fontWeight: 'bold' }}> The call will come from 913-322-8456,</span> please add this number to your contacts.
      </Typography>
      <Typography size={28} styles={{ marginTop: 20 }}>
        If you need help or have questions, you can contact the help desk at 1-888-799-8742 or use our live chat in the bottom right-hand corner of
        the screen.
      </Typography>
      <img
        src="https://triacentral.blob.core.windows.net/dev-storage/portal/images/InitialConfirmScreen.png"
        style={{ maxWidth: 465, width: '90%', marginLeft: 'auto', marginRight: 'auto', marginTop: 50, marginBottom: 30 }}
      />
    </StyledContainer>
  )
}

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  width: 96%;
  max-width: 1600px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
`
